module.exports = __webpack_public_path__ + "img/pif-letsstarted-banner.5b9c2119.svg";